module.exports = __webpack_public_path__ + "a85dfcc9df431fefa884df402d50f47b.png";